import { render, staticRenderFns } from "./HolidayDetail.vue?vue&type=template&id=ce76cf68"
import script from "../../controllers/holiday/holiday-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/holiday/holiday-detail.js?vue&type=script&lang=js&external"
import style0 from "./HolidayDetail.vue?vue&type=style&index=0&id=ce76cf68&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports